import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { useRouter } from "pages"
import { ScrollableArea } from "@nova/component-scrollable-area"
import { useClusteredGeolocatedProjects } from "features/map/layers/geolocated-project/useGeolocatedProjects"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { MarkerCluster } from "features/map/useClusteredMarkers"
import { ProjectExtended } from "@nova/schemas"
import { useEffect, useMemo, useRef } from "react"
import { clearActivePopup } from "../slice"

export const ProjectClusterPopup = ({ id }: { id: string }) => {
    const dispatch = useAppDispatch()
    const router = useRouter("/workspace/:workspaceId")
    const orgId = useAppSelector(selectActiveWorkspaceId())
    const clusteredProjects = useClusteredGeolocatedProjects({ orgId })
    const cluster = clusteredProjects.find(
        (marker): marker is MarkerCluster<ProjectExtended> =>
            marker.type === "cluster" && marker.id === id
    )
    const projects = useMemo(() => cluster?.items ?? [], [cluster])
    const initialProjectIdsRef = useRef(new Set(projects.map((project) => project.id)))
    useEffect(() => {
        const initialProjectIds = initialProjectIdsRef.current
        const membershipChanged =
            projects.length !== initialProjectIds.size ||
            projects.some((project) => !initialProjectIds.has(project.id))
        if (!projects.length || membershipChanged) {
            dispatch(clearActivePopup())
        }
    }, [clusteredProjects.length, dispatch, projects])
    return (
        <div className="pointer-events-auto w-[240px] rounded-xl bg-black-800 p-2 flex flex-col gap-0.5 backdrop-blur-sm">
            <div className="px-2 py-1 flex justify-between">
                <small className="xs text-white-400">Projects</small>
                <small className="xs text-white-400">{projects.length}</small>
            </div>
            <div>
                <ScrollableArea
                    className="max-h-[224px] shrink min-h-0"
                    onWheel={(e) => e.stopPropagation()}
                >
                    <div className="flex flex-col">
                        {projects.map((project) => {
                            return (
                                <router.Link
                                    key={project.id}
                                    to={{
                                        path: "/project/:projectId",
                                        params: { projectId: project.id },
                                    }}
                                >
                                    <div className="px-2 py-1.5 text-gray-50 truncate hover:bg-white-100">
                                        {project.name}
                                    </div>
                                </router.Link>
                            )
                        })}
                    </div>
                </ScrollableArea>
            </div>
        </div>
    )
}
